// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + ".js?id=" + {"240":"85d3b2e4ee5cae9f","353":"1bcea9dc287fe9e0","445":"c59f1749bea07b3f","823":"7480259e62f5752d"}[chunkId] + "";
};